<script>
  import { Slider, isDev } from '$client';
  import Item from './Item.svelte';
  export let data = [];
  export let type = 'gray';
  export let header = 'Отзывы';
  export let buttons = true;
  export let url = '';
  export let total;

  const media = [
    { size: 99999, gap: 40, count: 3 },
    { size: 1199.98, gap: 20, count: 3 },
    { size: 991.98, gap: 15, count: 2 },
    { size: 767.98, gap: 15, count: 1 },
  ];

  const testData = {
    get: key => testData[key][Math.floor(Math.random() * testData[key].length)],
    names: ['Александр', 'Александр Иванов', 'Иванов Александр Дмитриевич', 'Иванов Александр Дмитриевич JavaScript'],
    desc: 'lorem ipsum dolor sit amet, consectetur adip eget met  nulla et nonummy nib  nibh. Lorem ipsum dolor  sit amet, consectetur adip eget met nulla et non lorem ipsum dolor sit amet, consectetur adip eget met  nulla et nonummy nib  nibh. Lorem ipsum dolor  sit amet, consectetur adip eget met nulla et non',
  };

  const createReview = () => ({
    id: 1,
    attributes: {
      name: testData.get('names'),
      review: testData.desc,
      rating: Math.floor(Math.random() * 5),
      topic: null,
      img: null,
    },
  });

  $: if (!data.length && isDev()) data = new Array(10).fill({}).map(createReview);
</script>

<div itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating">
  <meta itemprop="ratingValue" content={data.reduce((acc, v) => acc + v.attributes.rating, 0) / data.length} />
  <meta itemprop="reviewCount" content={total ?? 131 + data.length} />
</div>
<Slider {url} {buttons} {type} {header} component={Item} {data} {media} />
